import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ModeToggle } from "./ModeToggle";
import { useAuth } from "@/hooks/useAuth";

export function SiteHeader() {
  const { user, signOut, isSigningOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      // Error handling is already done in the useAuth hook
      console.error("Logout error:", error);
    }
  };

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center justify-between gap-1 px-4 lg:gap-2 lg:px-6">
        <div className="flex items-center">
          <SidebarTrigger className="-ml-1" />
          <Separator
            orientation="vertical"
            className="mx-2 data-[orientation=vertical]:h-4"
          />
          <div className="flex space-x-4">
            <h1 className="text-xl font-semibold">FibboVoice</h1>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          {user && (
            <span className="text-sm text-muted-foreground">{user.email}</span>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={handleLogout}
            disabled={isSigningOut}
          >
            {isSigningOut ? "Logging out..." : "Logout"}
          </Button>
          <ModeToggle />
        </div>
      </div>
    </header>
  );
}
